import { createAction } from '@ngrx/store';

export const singleClickDisableAction = createAction('[SingleClickButtonDisabled] True');
export const singleClickEnableAction = createAction('[SingleClickButtonDisabled] False');
